/**
 * Control visibility of the dialog.
 */
Drupal.behaviors.toybox_dialog = {
  attach: function (context) {
    // We use `querySelectorAll` to ensure we can handle multiple dialogs.
    // This can be the case on certain form pages.
    const dialogWrapper = context.querySelectorAll(".js-dialog-wrapper");
    if (!dialogWrapper.length) {
      return;
    }

    for (const wrapper of dialogWrapper) {
      const dialog = wrapper.querySelector("dialog");

      if (!dialog) {
        return;
      }

      // Allow for closing the dialog with the close button.
      const closeButton = wrapper.querySelector(".js-dialog-close");
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          dialog.close();
          wrapper.setAttribute("data-hidden", "true");
        });
      }

      if (
        wrapper.hasAttribute("data-hidden") &&
        wrapper.getAttribute("data-hidden") === "false"
      ) {
        dialog.showModal();
      }

      const isClosable =
        wrapper.hasAttribute("data-closable") &&
        wrapper.getAttribute("data-closable") === "true";
      if (!isClosable) {
        this.handlePreventCloseOnEscapeKey(dialog);
      }
    }
  },
  handlePreventCloseOnEscapeKey: function (element) {
    element.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
      }
    });
  },
};
